import { HashLoader } from "react-spinners";
import TransparentHeader from "./TransparentHeader";
import Header from "./Header";

export const NewLoader = ({ color }) => {
  return (
    <>
      <TransparentHeader />

      <div className="fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-sm">
        <HashLoader
          color={color || "#82aae3"}
          loading
          size={60}
          speedMultiplier={1.2}
          aria-label="Loading"
        />
      </div>
    </>
  );
};
